__turbopack_context__.v({
  "FeatureContainer": "BrandPillar-module-scss-module__3bs4yq__FeatureContainer",
  "caption": "BrandPillar-module-scss-module__3bs4yq__caption",
  "captionBoxStyle": "BrandPillar-module-scss-module__3bs4yq__captionBoxStyle",
  "headerCont": "BrandPillar-module-scss-module__3bs4yq__headerCont",
  "highlightBody": "BrandPillar-module-scss-module__3bs4yq__highlightBody",
  "highlightBodyContent": "BrandPillar-module-scss-module__3bs4yq__highlightBodyContent",
  "highlightBox": "BrandPillar-module-scss-module__3bs4yq__highlightBox",
  "highlightHeader": "BrandPillar-module-scss-module__3bs4yq__highlightHeader",
  "hoverImage": "BrandPillar-module-scss-module__3bs4yq__hoverImage",
  "imageWrapper": "BrandPillar-module-scss-module__3bs4yq__imageWrapper",
  "pageEditingView": "BrandPillar-module-scss-module__3bs4yq__pageEditingView",
  "pillar0": "BrandPillar-module-scss-module__3bs4yq__pillar0",
  "pillar1": "BrandPillar-module-scss-module__3bs4yq__pillar1",
  "pillar2": "BrandPillar-module-scss-module__3bs4yq__pillar2",
});
